import React from 'react';
import { useLocation } from 'react-router-dom';

// Route to page title/subtitle, so the header reflects the real location
// rather than inventing content.
const PAGE_META: Record<string, { title: string; subtitle: string }> = {
  '/proposals': { title: 'Proposals', subtitle: 'Manage sales proposals' },
  '/configuration': { title: 'Configuration', subtitle: 'Pricing configuration' },
  '/dashboard': { title: 'Dashboard', subtitle: 'Overview and key metrics' },
};

const Header: React.FC = () => {
  const { pathname } = useLocation();
  const match = Object.keys(PAGE_META).find((path) => pathname.startsWith(path));
  const meta = match ? PAGE_META[match] : { title: 'Data360 Sales Toolkit', subtitle: '' };

  return (
    <header className="h-[60px] bg-white/80 backdrop-blur-xl border-b border-[#E2E5EA] flex-shrink-0 sticky top-0 z-40">
      <div className="h-full px-8 flex items-center justify-between">
        <div className="flex flex-col">
          <h1 className="font-heading text-[18px] font-semibold text-blueprint-blue">
            {meta.title}
          </h1>
          {meta.subtitle && (
            <p className="text-[11px] text-heritage-grey">{meta.subtitle}</p>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
